export const calculatorConfig = {
  id: 'golang-calculator',
  formName: 'price-technology',
  title: 'Request the price of your Go Development initiative',

  sections: [
    {
      name: 'specialists',
      type: 'team',
      blockType: 'counter',
      counterType: 'counter',
      defaultValue: 0,
      title: 'Your Back-end team',
      mobileTitles: {
        default: 'Your Back-end team',
        active: 'Your Back-end team',
        section: 'Your Back-end team',
      },
      items: ['Developer', 'Senior Developer', 'Architect'],
      accordion: true,
      borderBottom: false,
    },
    {
      name: 'additional_skills',
      type: 'skills',
      blockType: 'checkbox',
      counterType: 'checkbox',
      defaultValue: false,
      title: 'Top required skills',
      mobileTitles: {
        default: 'Top required skills',
        active: 'Top required skills',
        section: 'Top required skills',
      },
      items: [
        'K8s',
        'Docker',
        'Cloud platforms',
        'gRPC',
        'CI/CD',
        'SQL database',
        'NoSQL database',
      ],
      accordion: true,
      borderBottom: false,
    },
  ],
};
